import { CircularProgress, Paper, PaperProps, styled } from '@mui/material';
import { CenteredContainer } from '@ianesthesie-kit/core';
import React from 'react';

export const StandardDialogContainer = (props: PaperProps) => (
  <Paper
    sx={{
      p: 0,
      position: 'relative',
      maxWidth: 400,
      minWidth: {
        xs: 'unset',
        md: 400
      },
      minHeight: 200
    }}
    {...props}
  />
);

export const ZeroPaddingDialogContainer = styled(Paper)`
  padding: 0;
`;

export const DynamicDialogLoader = () => (
  <CenteredContainer
    minHeight={248}
    minWidth={{
      xs: 'unset',
      md: 400
    }}
  >
    <CircularProgress />
  </CenteredContainer>
);
